import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import helpers from '../../mixins/helpers';

const state = {
    id: 0,
    cuentaId: 0,
    codigo: '',
    nombre: '',
    // gastos: false,
    honorarios: false,
    rowVersion: null,

    gastosEnabled: false
};

const mutations = {
    updateField,

    'INICIALIZAR'(state, params) {
        state.id = params.rubroId;
        state.cuentaId = params.cuentaId;
        state.codigo = '';
        state.nombre = '';
        // state.gastos = false;
        state.honorarios = false;
        state.rowVersion = null;

        state.gastosEnabled = false;
    },
    'SET_RUBRO'(state, rubro) {
        state.codigo = rubro.codigo.trim();
        state.nombre = rubro.nombre.trim();
        // state.gastos = rubro.gastos;
        state.honorarios = rubro.honorarios;
        state.rowVersion = rubro.rowVersion;
    },

};

const actions = {
    inicializar: ( { commit }, params )  => {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR', params);
            
            let cuentaId = 0;
            let rubroId = 0;

            if (params.cuentaId) {
                cuentaId = params.cuentaId;
            }
            if (params.rubroId) {
                rubroId = params.rubroId;
            }

            if (cuentaId != 0) {
                apiAxios.get(`rubros/${cuentaId}/${rubroId}/abm`)
                .then(res => {
                    commit('SET_RUBRO', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                resolve();
            }
        })            
    },
    save ( { state } ) {
        return new Promise((resolve, reject) => {
            let save = true;
            let error = '';

            let codigo = '';
            if (!isNaN(state.codigo)) {
                let numeroCodigo = parseInt(state.codigo);
                codigo = numeroCodigo.toString().padStart(3, '0');
            } else {
                save = false;
                error = 'El código de rubro no es válido. Verifique la información ingresada.';
            }

            if (save) {
                let rubro= {
                    cuentaId: state.cuentaId,
                    codigo: codigo,
                    nombre: state.nombre.trim().toUpperCase(),
                    honorarios: (/true/i).test(state.honorarios)
                }

                let url = 'rubros';
                if (state.id != 0) {
                    url += '/' + state.id;
                    rubro.rowVersion = state.rowVersion;
                }
                apiAxios.post(url, rubro)
                    .then(() => resolve())
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                reject(error);
            }
        })
    },
    delete ( {}, rubroId ) {
        return new Promise((resolve, reject) => {
            apiAxios.post(`rubros/${rubroId}/delete`)
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })            
    },
};

const getters = {
    getField,
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}